// Pure label/format helpers shared across the Move V2 step views.
export var containerLabel = function (c) {
    if (!c)
        return '';
    var kind = c.isPallet ? 'Pallet' : 'Carton';
    return kind + " " + (c.serialNumber || c.containerId);
};
export var matchLabel = function (m) {
    if (m.matchType === 'location')
        return "Location " + m.locationSeqId;
    if (m.matchType === 'container')
        return containerLabel(m.container);
    if (m.matchType === 'asset')
        return "Asset " + m.assetId + " \u00B7 " + (m.productSku || m.productName || m.productId);
    return m.productName || m.productSku || m.productId || '';
};
// Secondary line for a scan-disambiguation row. For products it spells out ID and SKU separately so
// an id-match and a different product that merely shares the same SKU/UPC are clearly told apart.
export var matchSubLabel = function (m, t) {
    if (m.matchType === 'location')
        return t('Location');
    if (m.matchType === 'container')
        return t('Container');
    if (m.matchType === 'asset')
        return t('Asset');
    var parts = [t('Product'), t('ID') + " " + m.productId];
    if (m.productSku)
        parts.push(t('SKU') + " " + m.productSku);
    if (!m.requiresLocation && m.totalQuantityOnHand != null)
        parts.push(t('Qty') + " " + m.totalQuantityOnHand);
    return parts.join(' · ');
};
export var holdingLabel = function (h, t) {
    var _a;
    return h.containerId
        ? (((_a = h.containerTypeEnumId) === null || _a === void 0 ? void 0 : _a.startsWith('CtPallet')) ? t('Pallet') : t('Carton')) + " " + (h.serialNumber || h.containerId) + " \u00B7 " + t('Qty') + " " + h.quantityOnHand
        : t('Loose (no container)') + " \u00B7 " + t('Qty') + " " + h.quantityOnHand;
};
export var formatDate = function (d) {
    if (!d)
        return '';
    try {
        return new Date(d).toISOString().slice(0, 10);
    }
    catch (_a) {
        return String(d);
    }
};
export var lotLabel = function (l, t) {
    var parts = [l.lotNumber || l.lotId || t('No lot'), t('Qty') + " " + l.quantity];
    if (l.expirationDate)
        parts.push(t('Exp') + " " + formatDate(l.expirationDate));
    if (l.expired)
        parts.push(t('EXPIRED'));
    return parts.join(' · ');
};
